
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/success-story",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/success-story/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/success-story"])
      });
    }
  